import React from "react";
import PropTypes from "prop-types";

function parseDiscountNumber(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function formatMoney(value) {
  const parsed = parseDiscountNumber(value);
  if (parsed === null) {
    return "Sin definir";
  }

  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
  }).format(parsed);
}

export function hasConfiguredDiscount({ descuento, codigoDescuento }) {
  const parsedDiscount = parseDiscountNumber(descuento);
  return parsedDiscount !== null && parsedDiscount > 0 && typeof codigoDescuento === "string" && codigoDescuento.trim() !== "";
}

export function resolveDiscountFinalPrice({ precio, precioFinal, descuento }) {
  const storedFinalPrice = parseDiscountNumber(precioFinal);
  if (storedFinalPrice !== null) {
    return storedFinalPrice;
  }

  const basePrice = parseDiscountNumber(precio);
  const discountPercent = parseDiscountNumber(descuento);
  if (basePrice === null || discountPercent === null) {
    return null;
  }

  return Math.max(0, basePrice - (basePrice * discountPercent) / 100);
}

export default function EditarCursoDescuentosTab({
  codigoDescuento,
  descuento,
  precio,
  precioFinal,
}) {
  const hasDiscount = hasConfiguredDiscount({ descuento, codigoDescuento });
  const finalPrice = hasDiscount ? resolveDiscountFinalPrice({ precio, precioFinal, descuento }) : null;

  return (
    <>
      <h1>Listado de descuentos</h1>
      <p className="cc-help-text">
        Descuentos configurados para este curso. No se muestran acciones del sistema ni registros ajenos a descuentos.
      </p>

      {hasDiscount ? (
        <div className="cc-discount-list" aria-label="Descuentos configurados">
          <article className="cc-discount-card">
            <h2>{codigoDescuento.trim()}</h2>
            <dl>
              <div>
                <dt>Descuento</dt>
                <dd>{parseDiscountNumber(descuento)} %</dd>
              </div>
              <div>
                <dt>Precio base</dt>
                <dd>{formatMoney(precio)}</dd>
              </div>
              <div>
                <dt>Precio final</dt>
                <dd>{formatMoney(finalPrice)}</dd>
              </div>
            </dl>
          </article>
        </div>
      ) : (
        <p>No hay descuentos configurados.</p>
      )}
    </>
  );
}

EditarCursoDescuentosTab.propTypes = {
  codigoDescuento: PropTypes.string,
  descuento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  precio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  precioFinal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

EditarCursoDescuentosTab.defaultProps = {
  codigoDescuento: "",
  descuento: "",
  precio: "",
  precioFinal: null,
};
